import styled from "styled-components";
import { Assets } from "../../../common/styles/assets";

export const WebcamContainer = styled.div`
    width: 100%;
    height:auto;    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding:0;
    overflow: hidden;    
   
`;

export const PreviewImage = styled.img`
    width: 100%;
    height: auto;
    max-width: 100%;        
    padding:0;
    
`;

export const ButtonContainer = styled.div`
    width: 100%;
    height: auto;
    display: flex;        
    justify-content: center;
    align-items: center;
    flex-direction: column;    
    
    
`;

export const CaptureButton = styled.button`
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${Assets.primaryColor};
    color: #000;
    border: none;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: bold;
    font-family: 'Inter', Arial, sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover:not(:disabled) {
        transform: scale(1.05);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const RetakeButton = styled.button`
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    border: none;
    color: #fff;        
    padding: 12px 24px;
    font-size: 16px;
    font-weight: bold;
    font-family: 'Inter', Arial, sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
        background: #000;
        color: #fff;
    }
`;

